import { withSvgIcon } from './withSvgIcon';

export const BoldAdvancedApi = withSvgIcon(
  <>
    <path
      d="M8 3.35547L3.76834 5.26076C2.69209 5.74534 2 6.81597 2 7.99627V16.0075C2 17.1878 2.69209 18.2585 3.76834 18.7431L8 20.6483V18.455L4.58945 16.9194C4.2307 16.7579 4 16.401 4 16.0075V7.99627C4 7.60284 4.2307 7.24596 4.58945 7.08444L8 5.54884V3.35547Z"
      fill="currentColor"
    />
    <path
      d="M16 3.35547L20.2317 5.26076C21.3079 5.74534 22 6.81597 22 7.99627V16.0075C22 17.1878 21.3079 18.2585 20.2317 18.7431L16 20.6483V18.455L19.4106 16.9194C19.7693 16.7579 20 16.401 20 16.0075V7.99627C20 7.60284 19.7693 7.24596 19.4106 7.08444L16 5.54884V3.35547Z"
      fill="currentColor"
    />
    <path
      d="M7.99961 13.0995L15.9996 9.27344V11.4904L7.99961 15.3165V13.0995Z"
      fill="currentColor"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
